import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { Button, Col, Container, Row } from 'reactstrap';
import { useTrack } from '../../../../products/WLC/contexts/TrackContext';
import { useWeek } from '../../../../products/WLC/contexts/WeekContext';
import { getProductFromPath } from '../../utils';

const TrackWeekInterstitial = () => {
  const history = useHistory();
  const location = useLocation();
  const { metadata: trackMetadata, getWeekNumber } = useTrack();
  const { week } = useWeek();
  const productSlug = getProductFromPath();
  const weekNumber = week?.slug ? getWeekNumber(week.slug) : 0;
  const trackTitle = trackMetadata?.title || '';
  const isTrackPreview = !!location?.state?.isTrackPreview;

  const handlePreviewUpcomingWeeks = () => {
    history.push(`/products/${productSlug}/current-track`);
    window.scrollTo(0, 0);
  };

  if (isTrackPreview) {
    return (
      <div className="background-dark-purple">
        <Container className="text-white py-5 text-balance">
          <Row>
            <Col className="text-center">
              <Button color="purple" size="lg" onClick={handlePreviewUpcomingWeeks}>
                Go Back to Track Planner
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="background-dark-purple">
      <Container className="text-white py-5">
        <Row>
          <Col className="text-center text-white text-large">
            <p>
              You’re on Week <strong>{weekNumber}</strong> of the <strong>{trackTitle}</strong> track.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <p>
              <Button color="purple" size="lg" onClick={handlePreviewUpcomingWeeks}>
                Preview Upcoming Weeks
              </Button>
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="text-white text-small text-center">
            <p>
              <em>You can also update the order of your next tracks.</em>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default TrackWeekInterstitial;
